// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
* VARIABLES
*/
/*
* MIXINS
*/
.Modal__overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(3, 3, 3, 0.7);
  opacity: 1;
  pointer-events: all;
  z-index: 98;
}
.Modal__overlay.Modal__invisible {
  opacity: 0;
  z-index: -1;
  pointer-events: none;
}
.Modal__wrp {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
  width: 90vw;
  height: calc(100vh - 100px);
  overflow-y: auto;
  max-width: 100%;
  max-height: 100%;
  z-index: 99;
  pointer-events: all;
  background: #181818;
  border-radius: 5px;
}
@media (min-width: 640px) {
  .Modal__wrp {
    width: 80vw;
  }
}
@media (min-width: 768px) {
  .Modal__wrp {
    width: 65vw;
  }
}
@media (min-width: 1024px) {
  .Modal__wrp {
    width: 55vw;
  }
}
@media (min-width: 1450px) {
  .Modal__wrp {
    max-width: 750px;
    width: 100%;
  }
}
.Modal__wrp.Modal__invisible {
  z-index: -1;
  pointer-events: none;
}
.Modal__wrp::-webkit-scrollbar {
  display: none;
}
.Modal__closebtn {
  position: absolute;
  top: 2%;
  right: 2%;
  z-index: 1;
  display: inline-flex;
  padding: 8px;
  font-size: 18px;
  border-radius: 50%;
  cursor: pointer;
  margin: 0 5px;
  margin-bottom: 0.8em;
  background: #141414;
  color: #f2f2f2;
  border: 1px solid #f2f2f2;
  transition: all 0.3s ease-out;
  outline: none;
}
.Modal__closebtn:hover {
  background: #f2f2f2;
  color: #141414;
}
.Modal__image--wrp {
  position: relative;
}
.Modal__image--img {
  width: 100%;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.Modal__image--shadow {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20%;
  background: linear-gradient(180deg, transparent, rgba(14, 14, 14, 0.6), #181818);
}
.Modal__image--buttonswrp {
  position: absolute;
  bottom: 10%;
  left: 1.5em;
  display: flex;
  align-items: center;
}
@media (min-width: 640px) {
  .Modal__image--buttonswrp {
    left: 2em;
  }
}
.Modal__image--button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 120px;
  background-color: #e50914;
  color: #f2f2f2;
  padding: 10px 16px;
  margin-left: 0;
  border-radius: 6px;
  border: 0;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease-out;
}
@media (min-width: 400px) {
  .Modal__image--button {
    min-width: 150px;
    font-size: 14px;
    padding: 12px 20px;
  }
}
@media (min-width: 768px) {
  .Modal__image--button {
    font-size: 15px;
  }
}
.Modal__image--button:hover {
  background-color: rgb(204.4642857143, 8.0357142857, 17.8571428571);
}
.Modal__image--button span {
  margin-left: 8px;
}
.Modal__image--button-circular {
  display: inline-flex;
  padding: 10px;
  border-radius: 50%;
  font-size: 13px;
  cursor: pointer;
  margin: 0 5px;
  margin-left: 0.8em;
  background: transparent;
  color: #f2f2f2;
  border: 1px solid #f2f2f2;
  transition: all 0.3s ease-out;
  outline: none;
}
@media (min-width: 400px) {
  .Modal__image--button-circular {
    font-size: 14px;
  }
}
.Modal__image--button-circular:hover {
  background: #f2f2f2;
  color: #141414;
}
.Modal__image--button-circular:first-child {
  margin-left: 0;
  background: #f2f2f2;
  color: #141414;
}
.Modal__image--button-circular:first-child:hover {
  background: rgba(242, 242, 242, 0.7);
  border-color: rgba(242, 242, 242, 0.7);
}
.Modal__info--wrp {
  padding: 1em 1.5em;
}
@media (min-width: 640px) {
  .Modal__info--wrp {
    padding: 1.5em 2em;
  }
}
.Modal__info--title {
  font-size: 22px;
  line-height: 1.4;
  font-weight: 600;
  margin-bottom: 15px;
}
@media (min-width: 640px) {
  .Modal__info--title {
    font-size: 26px;
  }
}
.Modal__info--description {
  font-size: 14px;
  line-height: 1.7;
}
@media (min-width: 640px) {
  .Modal__info--description {
    font-size: 16px;
    line-height: 1.5;
  }
}
.Modal__info--line {
  border-color: rgba(121, 121, 121, 0.7);
  margin: 1em 0;
}
@media (min-width: 640px) {
  .Modal__info--line {
    margin: 1.5em 0;
  }
}
.Modal__info--otherTitle {
  font-size: 16px;
  line-height: 1.4;
  font-weight: 400;
  margin-bottom: 15px;
}
@media (min-width: 640px) {
  .Modal__info--otherTitle {
    font-size: 20px;
  }
}
.Modal__info--row {
  font-size: 12px;
  line-height: 1.6;
  margin: 0.5em;
  margin-left: 0;
  word-break: break-word;
}
.Modal__info--row-label {
  color: #777;
}
.Modal__info--row-description {
  color: #ddd;
}
@media (min-width: 640px) {
  .Modal__info--row {
    font-size: 14px;
    line-height: 1.5;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/_mixin.scss","webpack://./src/components/DetailModal/detailModal.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AAAA;;CAAA;AAKA;;CAAA;ACDE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,UAAA;EACA,mBAAA;EACA,WAAA;AAGJ;AADI;EACE,UAAA;EACA,WAAA;EACA,oBAAA;AAGN;AACE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;EACA,WAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBCnCU;EDoCV,kBAAA;AACJ;ADqCQ;ECpDN;IAiBI,WAAA;EAEJ;AACF;ADgCQ;ECpDN;IAqBI,WAAA;EAGJ;AACF;AD2BQ;ECpDN;IAyBI,WAAA;EAIJ;AACF;ADsBQ;ECpDN;IA6BI,gBAAA;IACA,WAAA;EAKJ;AACF;AAHI;EACE,WAAA;EACA,oBAAA;AAKN;AAFI;EACE,aAAA;AAIN;AAAE;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;EACA,mBC5EI;ED6EJ,cChFI;EDiFJ,yBAAA;EACA,6BAAA;EACA,aAAA;AAEJ;AAAI;EACE,mBCtFE;EDuFF,cCpFE;ADsFR;AAGI;EACE,kBAAA;AADN;AAGI;EACE,WAAA;EACA,2BAAA;EACA,4BAAA;AADN;AAGI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gFAAA;AADN;AAII;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAFN;ADpCQ;ECiCJ;IAQI,SAAA;EADN;AACF;AAII;EACE,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBC1HA;ED2HA,cC/HE;EDgIF,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,gCC5HM;ED6HN,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,6BAAA;AAFN;AD3DQ;EC6CJ;IAmBI,gBAAA;IACA,eAAA;IACA,kBAAA;EADN;AACF;ADlEQ;EC6CJ;IAyBI,eAAA;EAAN;AACF;AAEM;EACE,kEAAA;AAAR;AAGM;EACE,gBAAA;AADR;AAIM;EACE,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,cCtKA;EDuKA,yBAAA;EACA,6BAAA;EACA,aAAA;AAFR;AD3FQ;ECiFF;IAeI,eAAA;EADR;AACF;AAGQ;EACE,mBChLF;EDiLE,cC9KF;AD6KR;AAIQ;EACE,cAAA;EACA,mBCtLF;EDuLE,cCpLF;ADkLR;AAIU;EACE,oCAAA;EACA,sCAAA;AAFZ;AAUI;EACE,kBAAA;AARN;ADhHQ;ECuHJ;IAII,kBAAA;EAPN;AACF;AAUI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AARN;AD3HQ;EC+HJ;IAOI,eAAA;EAPN;AACF;AAUI;EACE,eAAA;EACA,gBAAA;AARN;ADpIQ;EC0IJ;IAKI,eAAA;IACA,gBAAA;EAPN;AACF;AAUI;EACE,sCAAA;EACA,aAAA;AARN;AD9IQ;ECoJJ;IAKI,eAAA;EAPN;AACF;AAUI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AARN;ADzJQ;EC6JJ;IAOI,eAAA;EAPN;AACF;AAUI;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;AARN;AAUM;EACE,WAAA;AARR;AAWM;EACE,WAAA;AATR;AD3KQ;ECwKJ;IAgBI,eAAA;IACA,gBAAA;EATN;AACF","sourcesContent":["/*\n* VARIABLES\n*/\n$breakpoints: (ll: 1450px, lg: 1024px, md: 768px, sm: 640px, xs: 400px) !default;\n\n/*\n* MIXINS\n*/\n@mixin mq($min: null, $max: null) {\n    $min-type: type-of($min);\n    $max-type: type-of($max);\n\n    @if $min-type==string {\n        @if $min==xs {\n            $min: \"(min-width: #{map-get($breakpoints, xs)})\";\n        }\n        @else if $min==sm {\n            $min: \"(min-width: #{map-get($breakpoints, sm)})\";\n        }\n        @else if $min==md {\n            $min: \"(min-width: #{map-get($breakpoints, md)})\";\n        }\n        @else if $min==lg {\n            $min: \"(min-width: #{map-get($breakpoints, lg)})\";\n        }\n        @else if $min==ll {\n            $min: \"(min-width: #{map-get($breakpoints, ll)})\";\n        }\n        @else {\n            @warn \"mq mixin supports: sm, md, lg, ll\";\n        }\n    }\n    @else if $min-type==number {\n        $min: \"(min-width: #{$min})\";\n    }\n\n    @if $max-type==string {\n        @if $max==xs {\n            $max: \"(max-width: #{map-get($breakpoints, xs) - 1})\";\n        }\n        @else if $max==sm {\n            $max: \"(max-width: #{map-get($breakpoints, sm) - 1})\";\n        }\n        @else if $max==md {\n            $max: \"(max-width: #{map-get($breakpoints, md) - 1})\";\n        }\n        @else if $max==lg {\n            $max: \"(max-width: #{map-get($breakpoints, lg) - 1})\";\n        }\n        @else if $max==ll {\n            $max: \"(max-width: #{map-get($breakpoints, ll) - 1})\";\n        }\n        @else {\n            @warn \"mq mixin supports: xs, sm, md, lg, ll\";\n        }\n    }\n\n    @else if $max-type==number {\n        $max: \"(max-width: #{$max})\";\n    }\n\n    $query: false;\n    @if $min and $max {\n        $query: \"#{$min} and #{$max}\";\n    }\n    @else if $min {\n        $query: \"#{$min}\";\n    }\n    @else if $max {\n        $query: \"#{$max}\";\n    }\n\n    @if (not $query) {\n        @warn \"Invalid media query\";\n    }\n    @else {\n        @media #{$query} {\n            @content;\n        }\n    }\n}\n\n@mixin mob() {\n    @include mq(null, md) {\n        @content;\n    }\n}\n\n@mixin smart() {\n    @include mq(null, sm) {\n        @content;\n    }\n}\n\n@mixin tab-portrait() {\n    @include mq(sm, md) {\n        @content;\n    }\n}\n\n@mixin tab-landscape() {\n    @include mq(md, lg) {\n        @content;\n    }\n}\n\n@mixin desk() {\n    @include mq(lg) {\n        @content;\n    }\n}","@import '../../scss/variables';\n@import '../../scss/mixin';\n\n.Modal {\n  &__overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba($pure-black, 0.7);\n    opacity: 1;\n    pointer-events: all;\n    z-index: 98;\n\n    &.Modal__invisible {\n      opacity: 0;\n      z-index: -1;\n      pointer-events: none;\n    }\n  }\n\n  &__wrp {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: block;\n    width: 90vw;\n    height: calc(100vh - 100px);\n    overflow-y: auto;\n    max-width: 100%;\n    max-height: 100%;\n    z-index: 99;\n    pointer-events: all;\n    background: $light-black;\n    border-radius: 5px;\n\n    @include mq('sm') {\n      width: 80vw;\n    }\n\n    @include mq('md') {\n      width: 65vw;\n    }\n\n    @include mq('lg') {\n      width: 55vw;\n    }\n\n    @include mq('ll') {\n      max-width: 750px;\n      width: 100%;\n    }\n\n    &.Modal__invisible {\n      z-index: -1;\n      pointer-events: none;\n    }\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  &__closebtn {\n    position: absolute;\n    top: 2%;\n    right: 2%;\n    z-index: 1;\n    display: inline-flex;\n    padding: 8px;\n    font-size: 18px;\n    border-radius: 50%;\n    cursor: pointer;\n    margin: 0 5px;\n    margin-bottom: 0.8em;\n    background: $black;\n    color: $white;\n    border: 1px solid $white;\n    transition: all 0.3s ease-out;\n    outline: none;\n\n    &:hover {\n      background: $white;\n      color: $black;\n    }\n  }\n\n  &__image {\n    &--wrp {\n      position: relative;\n    }\n    &--img {\n      width: 100%;\n      border-top-left-radius: 5px;\n      border-top-right-radius: 5px;\n    }\n    &--shadow {\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      height: 20%;\n      background: linear-gradient(180deg, transparent, rgba(14, 14, 14, 0.6), $light-black);\n    }\n\n    &--buttonswrp {\n      position: absolute;\n      bottom: 10%;\n      left: 1.5em;\n      display: flex;\n      align-items: center;\n\n      @include mq('sm') {\n        left: 2em;\n      }\n    }\n\n    &--button {\n      display: inline-flex;\n      justify-content: center;\n      align-items: center;\n      min-width: 120px;\n      background-color: $red;\n      color: $white;\n      padding: 10px 16px;\n      margin-left: 0;\n      border-radius: 6px;\n      border: 0;\n      font-family: $main-font;\n      font-size: 13px;\n      font-weight: 500;\n      cursor: pointer;\n      text-decoration: none;\n      transition: all 0.2s ease-out;\n\n      @include mq('xs'){\n        min-width: 150px;\n        font-size: 14px;\n        padding: 12px 20px;\n      }\n\n      @include mq('md'){\n        font-size: 15px;\n      }\n\n      &:hover {\n        background-color: darken($red, 5);\n      }\n\n      span {\n        margin-left: 8px;\n      }\n\n      &-circular {\n        display: inline-flex;\n        padding: 10px;\n        border-radius: 50%;\n        font-size: 13px;\n        cursor: pointer;\n        margin: 0 5px;\n        margin-left: 0.8em;\n        background: transparent;\n        color: $white;\n        border: 1px solid $white;\n        transition: all 0.3s ease-out;\n        outline: none;\n\n        @include mq('xs'){\n          font-size: 14px;\n        }\n\n        &:hover {\n          background: $white;\n          color: $black;\n        }\n\n        &:first-child {\n          margin-left: 0;\n          background: $white;\n          color: $black;\n\n          &:hover {\n            background: rgba($white, 0.7);\n            border-color: rgba($white, 0.7);\n          }\n        }\n      }\n    }\n  }\n\n  &__info {\n    &--wrp {\n      padding: 1em 1.5em;\n\n      @include mq('sm') {\n        padding: 1.5em 2em;\n      }\n    }\n\n    &--title {\n      font-size: 22px;\n      line-height: 1.4;\n      font-weight: 600;\n      margin-bottom: 15px;\n\n      @include mq('sm') {\n        font-size: 26px;\n      }\n    }\n\n    &--description {\n      font-size: 14px;\n      line-height: 1.7;\n\n      @include mq('sm') {\n        font-size: 16px;\n        line-height: 1.5;\n      }\n    }\n\n    &--line {\n      border-color: rgba(121,121,121,0.7);\n      margin: 1em 0;\n\n      @include mq('sm') {\n        margin: 1.5em 0;\n      }\n    }\n\n    &--otherTitle {\n      font-size: 16px;\n      line-height: 1.4;\n      font-weight: 400;\n      margin-bottom: 15px;\n\n      @include mq('sm') {\n        font-size: 20px;\n      }\n    }\n\n    &--row {\n      font-size: 12px;\n      line-height: 1.6;\n      margin: .5em;\n      margin-left: 0;\n      word-break: break-word;\n\n      &-label {\n        color: #777;\n      }\n\n      &-description {\n        color: #ddd;\n      }\n\n      @include mq('sm') {\n        font-size: 14px;\n        line-height: 1.5;\n      }\n    }\n  }\n}","$white: #f2f2f2;\n$pure-black: #030303;\n$light-black: #181818;\n$black: #141414;\n$red: #e50914;\n$grey: #101011;\n$blue-google: #1356c7;\n\n$main-font: 'Inter', sans-serif;\n$fakeflix-font: 'Bebas Neue', cursive;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
